import { render, staticRenderFns } from "./EstadosCiviles.vue?vue&type=template&id=5b737962"
import script from "./EstadosCiviles.vue?vue&type=script&lang=js"
export * from "./EstadosCiviles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports